<template>
  <div id="DaneWejsciowe">

    <template v-if="listaPrefixu">
      <ul style="padding: 0px;margin-bottom: 1px;">
        <li style="min-height: 28px;
          display: block;  padding: 2px 12px 0px 8px;  border-radius: 5px;  border: 1px solid #e8e8e8;  font-size: 14px;
          background: #535353;  border-radius: 0px;  color:white;cursor: pointer;
          text-align: left;" @click="toggleListRodzajSzaf()">{{titlePrefix}}
          <span v-if="!toggleList" style="float:right">
            <svg style="color: #999" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
              <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
            </svg>
          </span>
          <span v-else style="float:right">
            <svg style="color: #999" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
              <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
            </svg>
          </span>
        </li>
        <ul v-if="toggleList" style="position: absolute; background: white; z-index: 1; width: 100%; max-width: 544px;text-align: left; list-style: none; padding: 0px 15px;  box-shadow: 2px 4px 4px #dfdddd;">
          <li v-for="prefix in listaPrefixu" :key="prefix" style="padding: 6px 4px;" class="prefixList" @click="selectedPrefix(prefix)">
            <!-- <img width="30" :src="require('../assets/img/szafa/'+prefix+'.png')"/> -->
            <img width="30" :src="urlImagesSzafa(prefix)"/>
            {{ $t('message.' + prefix) }}</li>
        </ul>
      </ul>
    </template>
    <template v-if="lista_szaf.length > 0 && typ != ''">
      <multiselect v-model="selectedSzafa" :options="lista_szaf" selectLabel="" :hide-selected="false" :searchable="false" deselectLabel="" selectedLabel="" class="main" :max-height="350"
      :placeholder="$t('message.model_szafy')" label="label" track-by="label" @input="wybranie_szafy()"></multiselect>
    </template>
    <template v-else>
      <multiselect disabled :options="[]" :custom-label="namePozostale" :placeholder="$t('message.model_szafy')"></multiselect>
    </template>

    <div class="form-group" style="margin-bottom:4px;margin-top: 10px;">
      <Szafa :szafa='selectedSzafa' :clearView='clearViewSzafa'/>
    </div>
    <div class="form-group" style="text-align: left;margin-left: 10px;">
      <!-- <div class="form-check"> -->
      <label class="check-container">
        <span :id="(Object.keys(this.selectedSzafa).length === 0) ? 'turnOff' : ''">{{$t('message.same_akces')}}</span>
        <input type="checkbox" class="form-check-input" id="flexCheckChecked"
        :disabled="Object.keys(this.selectedSzafa).length === 0" v-model="sameAkcesoria" @change="set_same_akcesoria()">
        <span class="checkmark"></span>
      </label>
    </div>

    <div class="form-group">
      <Akcesorium :akcesorium='selectedAkcesoria' :clearView='clearViewAkcesorium' @newAttrAkcesorium='clicked_wpk'/>
    </div>

    <div class="form-group" style="height: 40px;margin: 0px;">
      <SearchPanel/>
      <SortPanel/>
    </div>

    <div class="accordion" id="accordionExample">
      <div class="card" v-if="ListaAkcesoria && ListaAkcesoria.akcesoria && ListaAkcesoria.akcesoria.length>0">
        <div class="card-header" id="headingOne">
          <h2 class="mb-0">
            <button class="btn btn-link" type="button" data-toggle="collapse" aria-expanded="true" aria-controls="collapseOne"
            :data-target="(ListaAkcesoria && ListaAkcesoria.akcesoria && ListaAkcesoria.akcesoria.length>0) ? '#collapseOne' : ''">
            {{$t('message.model_akces')}}
            </button>
          </h2>
        </div>
        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
          <div class="card-body" style="min-height: 70px;max-height: 250px;overflow-y: auto;">
            <ul>
              <li v-for="(row, indexAkcesoria) in ListaAkcesoria.akcesoria" :key="indexAkcesoria" @click="wybranie_akcesorium('pozostale', row)">
                <div style="display: inline-block;width: 100%;">
                  <div style="width: 100px; height:60px;float: left;"><img style="width: auto;  padding: 10px;  height: auto;  max-height: 60px;" :src="urlImagesProduct(row.symbol)" /></div>
                  <div>
                    <b style="font-size: 14px;"> {{row.symbol}}</b><br>
                    <em style="font-size: 12px;">{{row.nazwa}}</em>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="card" v-if="ListaAkcesoria && ListaAkcesoria.obudowy && ListaAkcesoria.obudowy.length>0">
        <div class="card-header" id="headingTwo">
          <h2 class="mb-0">
            <button class="btn btn-link collapsed" type="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapseTwo"
            :data-target="(ListaAkcesoria && ListaAkcesoria.obudowy && ListaAkcesoria.obudowy.length>0) ? '#collapseTwo' : ''">
            {{$t('message.model_akces_obudowy')}}
            </button>
          </h2>
        </div>
        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
          <div class="card-body" style="min-height: 70px;max-height: 250px;overflow-y: auto;">
            <ul>
              <li v-for="(row, indexObudowy) in ListaAkcesoria.obudowy" :key="indexObudowy" @click="wybranie_akcesorium('obudowy', row)">
                <div style="display: inline-block;width: 100%;">
                  <div style="width: 100px; height:60px;float: left;"><img style="width: auto;  padding: 10px;  height: auto;  max-height: 60px;" :src="urlImagesProduct(row.symbol)" /></div>
                  <div>
                    <b style="font-size: 14px;"> {{row.symbol}}</b><br>
                    <em style="font-size: 12px;">{{row.nazwa}}</em>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="card" v-if="ListaAkcesoria && ListaAkcesoria.switche && ListaAkcesoria.switche.length>0">
        <div class="card-header" id="headingThree">
          <h2 class="mb-0">
            <button class="btn btn-link collapsed" type="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapseThree"
            :data-target="(ListaAkcesoria && ListaAkcesoria.switche && ListaAkcesoria.switche.length>0) ? '#collapseThree' : ''">
            {{$t('message.model_akces_switche')}}
            </button>
          </h2>
        </div>
        <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
          <div class="card-body" style="min-height: 70px;max-height: 250px;overflow-y: auto;">
            <ul>
              <li v-for="(row, indexSwitche) in ListaAkcesoria.switche" :key="indexSwitche" @click="wybranie_akcesorium('switche', row)">
                <div style="display: inline-block;width: 100%;">
                  <div style="width: 100px; height:60px;float: left;"><img style="width: auto;  padding: 10px;  height: auto;  max-height: 60px;" :src="urlImagesProduct(row.symbol)" /></div>
                  <div>
                    <b style="font-size: 14px;"> {{row.symbol}}</b><br>
                    <em style="font-size: 12px;">{{row.nazwa}}</em>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="card" v-if="ListaAkcesoria && ListaAkcesoria.zasilacze && ListaAkcesoria.zasilacze.length>0">
        <div class="card-header" id="headingFour">
          <h2 class="mb-0">
            <button class="btn btn-link collapsed" type="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapseFour"
            :data-target="(ListaAkcesoria && ListaAkcesoria.zasilacze && ListaAkcesoria.zasilacze.length>0) ? '#collapseFour' : ''">
            {{$t('message.model_akces_zasilacze')}}
            </button>
          </h2>
        </div>
        <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
          <div class="card-body" style="min-height: 70px;max-height: 250px;overflow-y: auto;">
            <ul>
              <li v-for="(row, indexZasilacze) in ListaAkcesoria.zasilacze" :key="indexZasilacze" @click="wybranie_akcesorium('zasilacze', row)">
                <div style="display: inline-block;width: 100%;">
                  <div style="width: 100px; height:60px;float: left;"><img style="width: auto;  padding: 10px;  height: auto;  max-height: 60px;" :src="urlImagesProduct(row.symbol)" /></div>
                  <div>
                    <b style="font-size: 14px;"> {{row.symbol}}</b><br>
                    <em style="font-size: 12px;">{{row.nazwa}}</em>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group" style="margin-bottom: 10px;text-align: left;margin-top: 2px;">
      <button v-if="ListaAkcesoria.akcesoria" @click="my_akcesorium()" class="btn btn-secondary" style="padding: 0px 15px;border-radius: 0px;">
        {{$t('message.produkt_klienta')}}
      </button>
    </div>

    <div class="form-group" style="text-align: left;height: 23px;margin: 0px;width: 350px;" v-if="$i18n.locale === 'pl'">
      <label class="check-container" style="margin-right: 15px;">
        <span style="float: left;margin-right: 20px;" :id="(Object.keys(this.selectedSzafa).length === 0) ? 'turnOff' : ''">
          {{$t('message.rabat')}}</span>
        <input type="checkbox" class="form-check-input" id="flexCheckChecked"
        v-model="rabatCB" :disabled="disabledRabat" @change="set_rabat()">
        <span class="checkmark"></span>
      </label>
      <label v-if="rabatCB === true" class="form-check-label" for="flexCheckChecked" style="margin-left: 0px;">{{$t('message.wysokosc_rabatu')}} [%]</label>
      <input v-if="rabatCB === true" v-model="rabatValue" @input="set_rabat()" class="form-check-input inputRabat" style="color: black;font-weight: normal;" type="number" id="flexCheckChecked" min=0 max=99>

    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'

import Szafa from './View/Szafa'
import Akcesorium from './View/Akcesorium'
import { app } from '../mixins/app'
import SearchPanel from './Modules/SearchPanel'
import SortPanel from './Modules/SortPanel'

export default {
  name: 'DaneWejsciowe',
  mixins: [app],
  // mixins: [app, calculation],
  data () {
    return {
      selectedSzafa: [],
      selectedAkcesoria: [],
      items: [],
      typ: '',
      szafa: '',
      akcesorium_zasilacze: {},
      akcesorium_switche: {},
      akcesorium_obudowy: {},
      akcesorium_pozostale: {},
      clearViewSzafa: true,
      clearViewAkcesorium: true,
      sameAkcesoria: false,
      rabatCB: false,
      rabatValue: 0,
      activeSort: 'symbol',
      listaPrefixu: ['RWAG', 'RWAB', 'RWA', 'RWG', 'RWB', 'RW', 'RWD', 'RWDAG', 'RKG', 'RS', 'RSP', 'ZRS'],
      searching: '',
      listSearchProduct: [],
      toggleList: false
    }
  },
  components: {
    Szafa,
    Akcesorium,
    Multiselect,
    SearchPanel,
    SortPanel
  },
  watch: {
    loadFile (newValue) {
      if (newValue) {
        this.typ = this.inputs.szafaPrefix
        this.clearViewSzafa = false
        this.sameAkcesoria = this.inputs.sameAkcesoria
        this.selectedSzafa = JSON.parse(JSON.stringify(this.outputs.szafa)) //  Object.assign([], this.outputs.szafa)
        this.get_akcesoria(this.selectedSzafa.value, this.selectedSzafa.wysokosc_montazowa, 'symbol')
        this.rabatCB = this.inputs.rabatCB
        this.rabatValue = this.inputs.rabatValue

        this.$store.commit('app/SET_LOAD_FILE', false)
      }
    },
    '$i18n.locale' (newValue) {
      this.$store.dispatch('products/load_all_szafy', this.$i18n.locale)
      if (Object.keys(this.outputs.szafa).length > 0) {
        window.location.reload()
      }
    }
  },
  computed: {
    ...mapGetters('app', ['inputs', 'outputs', 'loadFile']),
    ...mapGetters('products', ['ListaSzafy', 'ListaAkcesoria']),
    titlePrefix () {
      return (this.typ === '') ? this.$t('message.rodzaj_szafy') : this.$t('message.' + this.typ)
    },
    // lista_prefixu () {
    //   var arr = []
    //   if (this.ListaSzafy.length > 0) {
    //     this.ListaSzafy.filter(item => {
    //       if (!arr.includes(item.prefix)) {
    //         arr.push(item.prefix)
    //       }
    //     })
    //   }
    //   return arr
    // },
    lista_szaf () {
      var arr = []
      var numeral = require('numeral')
      if (this.ListaSzafy.length > 0) {
        // arr = this.ListaSzafy.filter(item => (item.prefix === this.typ))
        var self = this
        this.ListaSzafy.filter(function (item) {
          if (item.prefix === self.typ) {
            var szerkosc = numeral(item.szerkosc)
            var glebokosc = numeral(item.glebokosc)
            var u = numeral(item.wysokosc_montazowa)
            if (self.typ === 'RS' || self.typ === 'ZRS') {
              item.value = self.typ + '_' + szerkosc.value() + '_' + glebokosc.value()
            } else {
              item.value = self.typ + '_' + glebokosc.value()
            }
            item.label = u.value() + '/' + szerkosc.value() + 'x' + glebokosc.value()
            arr.push(item)
          }
        })
        // wyskosc_montazowa U / szerkosc x glebokosc
      }
      return arr
    },
    disabledRabat () {
      if (Object.keys(this.selectedSzafa).length > 0) {
        return false
      }
      return true
    },
    SearchProduct () {
      return this.listSearchProduct
    }
  },
  methods: {
    getImgThumbs (symbol) {
      return '../assets/img/produkty/' + symbol + '_1.png'
    },
    nameZasilacze ({ symbol, nazwa }) {
      if (symbol === undefined && nazwa === undefined) {
        return this.$t('message.model_akces_zasilacze')
      }
      if (this.activeSort === 'symbol') {
        return `${symbol} — ${nazwa}`
      } else {
        return `${nazwa} — ${symbol}`
      }
    },
    nameSwitche ({ symbol, nazwa }) {
      if (symbol === undefined && nazwa === undefined) {
        return this.$t('message.model_akces_switche')
      }
      if (this.activeSort === 'symbol') {
        return `${symbol} — ${nazwa}`
      } else {
        return `${nazwa} — ${symbol}`
      }
    },
    nameObudowy ({ symbol, nazwa }) {
      if (symbol === undefined && nazwa === undefined) {
        return this.$t('message.model_akces_obudowy')
      }
      if (this.activeSort === 'symbol') {
        return `${symbol} — ${nazwa}`
      } else {
        return `${nazwa} — ${symbol}`
      }
    },
    namePozostale ({ symbol, nazwa }) {
      if (symbol === undefined && nazwa === undefined) {
        return this.$t('message.model_akces')
      }
      if (this.activeSort === 'symbol') {
        return `${symbol} — ${nazwa}`
      } else {
        return `${nazwa} — ${symbol}`
      }
    },
    namePrefix (val) {
      return this.$t('message.' + val)
    },
    // get_config () {
    //   this.$store.commit('app/SET_CONFIG', this.config)
    //   // console.log(this.produkty_szafy)
    // },
    toggleListRodzajSzaf () {
      this.toggleList = !this.toggleList
    },
    selectedPrefix (prefix) {
      this.toggleList = false
      this.typ = prefix
      this.clearViewSzafa = true
      this.clearViewAkcesorium = true
      this.szafa = ''
      this.selectedSzafa = []
      this.clear_v_models()
      this.$store.commit('app/UPDATED_INPUTS', {'name': 'szafaPrefix', 'value': this.typ})
      this.$store.commit('app/REMOVE_IN_OUTPUTS')
      if (this.loadFile) {
        this.$store.commit('app/SET_LOAD_FILE', false)
      }
    },
    get_szafy () {
      this.$store.dispatch('products/load_all_szafy', this.$i18n.locale)
      // this.$store.commit('products/SET_LIST_SZAFY', this.produkty_szafy)
      // this.changeValueOutputs('szafa', 'array', this.produkty_szafy[0])
      // this.check_depth_rack(this.produkty_szafy[0].attributes.wysokosc, this.produkty_szafy)
    },
    get_all_akcesoria () {
      this.$store.dispatch('products/load_all_list_akcesoria', this.$i18n.locale)
    },
    get_akcesoria (kod, wysokosc, sort) {
      this.$store.dispatch('products/load_list_akcesoria', [kod, wysokosc, sort, this.$i18n.locale])
      // console.log(this.produkty_akcesoria)
    },
    clear_v_models () {
      this.akcesorium_zasilacze = {}
      this.akcesorium_switche = {}
      this.akcesorium_obudowy = {}
      this.akcesorium_pozostale = {}
    },
    wybranie_prefix () {
      this.clearViewSzafa = true
      this.clearViewAkcesorium = true
      this.szafa = ''
      this.selectedSzafa = []
      this.clear_v_models()
      this.$store.commit('app/UPDATED_INPUTS', {'name': 'szafaPrefix', 'value': this.typ})
      this.$store.commit('app/REMOVE_IN_OUTPUTS')
      if (this.loadFile) {
        this.$store.commit('app/SET_LOAD_FILE', false)
      }
    },
    wybranie_szafy () {
      console.log('--- wybranie_szafy ---')
      window.dataLayer.push({'event': 'model-rack-click', 'label': 'Wybór modelu szafy', 'action': 'click', 'value': this.selectedSzafa.symbol})
      this.clearViewSzafa = false
      this.clearViewAkcesorium = true
      this.clear_v_models()
      this.$store.commit('app/REMOVE_IN_OUTPUTS')
      this.$store.commit('app/UPDATED_OUTPUTS', {'name': 'szafa', 'value': this.selectedSzafa})
      this.get_akcesoria(this.selectedSzafa.value, this.selectedSzafa.wysokosc_montazowa, 'symbol')
      if (this.loadFile) {
        this.$store.commit('app/SET_LOAD_FILE', false)
      }
    },
    wybranie_akcesorium (grupa, item) {
      console.log('--- wybranie_akcesorium ---')
      // console.log('grupa', grupa)
      // console.log('item', item)
      this.clearViewAkcesorium = false
      // var selected = []
      // if (grupa === 'zasilacze') {
      //   this.akcesorium_switche = {}
      //   this.akcesorium_obudowy = {}
      //   this.akcesorium_pozostale = {}
      //   selected = this.akcesorium_zasilacze
      // } else if (grupa === 'switche') {
      //   this.akcesorium_zasilacze = {}
      //   this.akcesorium_obudowy = {}
      //   this.akcesorium_pozostale = {}
      //   selected = this.akcesorium_switche
      // } else if (grupa === 'obudowy') {
      //   this.akcesorium_zasilacze = {}
      //   this.akcesorium_switche = {}
      //   this.akcesorium_pozostale = {}
      //   selected = this.akcesorium_obudowy
      // } else if (grupa === 'pozostale') {
      //   this.akcesorium_zasilacze = {}
      //   this.akcesorium_switche = {}
      //   this.akcesorium_obudowy = {}
      //   selected = this.akcesorium_pozostale
      // } else {
      //   this.akcesorium_zasilacze = {}
      //   this.akcesorium_switche = {}
      //   this.akcesorium_obudowy = {}
      //   this.akcesorium_pozostale = {}
      // }

      if (Object.keys(item).length > 0) {
        this.$store.commit('app/ADD_ITEM', item)
        // this.$store.commit('app/ADD_ITEMS', ['przod', selected])
      }
      this.selectedAkcesoria = item
    },
    // removeElement (item) {
    //   this.items.splice(item, 1)
    // },
    dodanie_do_szafy () {
      console.log('--- dodanie_do_szafy ---')
      this.$emit('clicked', this.selectedAkcesoria)
      // this.items.push(this.selectedAkcesoria.symbol)
      if (Object.keys(this.selectedAkcesoria).length > 0) {
        this.$store.commit('app/ADD_ITEM', this.selectedAkcesoria)
      }
    },
    set_same_akcesoria () {
      this.$store.commit('app/UPDATED_INPUTS', {name: 'sameAkcesoria', value: this.sameAkcesoria})
    },
    set_rabat () {
      if (this.rabatCB) {
        if (this.rabatValue < 0) {
          this.rabatValue = 0
        }
        if (this.rabatValue > 99) {
          this.rabatValue = 99
        }
      } else {
        this.rabatValue = 0
      }
      this.$store.commit('app/UPDATED_INPUTS', {name: 'rabatCB', value: this.rabatCB})
      this.$store.commit('app/UPDATED_INPUTS', {name: 'rabatValue', value: this.rabatValue})
    },
    sortowanie (val) {
      if (this.activeSort === val) {

      } else {
        this.activeSort = val
        if (this.selectedSzafa.value && this.selectedSzafa.wysokosc_montazowa) {
          this.get_akcesoria(this.selectedSzafa.value, this.selectedSzafa.wysokosc_montazowa, val)
        }
      }
    },
    my_akcesorium () {
      this.clearViewAkcesorium = false
      this.akcesorium_zasilacze = {}
      this.akcesorium_switche = {}
      this.akcesorium_obudowy = {}
      this.akcesorium_pozostale = {}
      // produkt_klienta

      var nameProduct = this.$i18n.messages[this.$i18n.locale]['message']['produkt_klienta']
      var kod = (this.$i18n.locale === 'pl') ? 'WPK000' : 'COP000'

      this.selectedAkcesoria = {
        'symbol': kod, 'id': 0, 'szerokosc_montazowa': '0', 'glebokosc_montazowa': 0, 'wysokosc_montazowa': '1', 'szerkosc': '0', 'wysokosc': '0', 'glebokosc': '0', 'nazwa': nameProduct, 'waga': '0', 'cena': '0', 'poza': null, 'podzespoly': 0, 'personal': true}
      this.$store.commit('app/ADD_ITEM', this.selectedAkcesoria)
    },
    clicked_wpk (val) {
      this.selectedAkcesoria = {
        'symbol': val.kod, 'id': 0, 'szerokosc_montazowa': '0', 'glebokosc_montazowa': 0, 'wysokosc_montazowa': val.iloscU, 'szerkosc': '0', 'wysokosc': '0', 'glebokosc': '0', 'nazwa': val.nazwa, 'waga': '0', 'cena': '0', 'poza': null, 'podzespoly': 0, 'personal': true}
      this.$store.commit('app/ADD_ITEM', this.selectedAkcesoria)
    },
    search_product () {
      if (event.keyCode === 13) {
      } else {
        this.listSearchProduct = []
        if (this.searching.length > 2) {
          this.ListaAkcesoria.akcesoria.filter((item) => {
          // console.log(item.symbol.startsWith(this.searching))
            if (item.symbol.toLowerCase().includes(this.searching.toLowerCase()) || item.nazwa.toLowerCase().includes(this.searching.toLowerCase())) {
              item.grupa = 'pozostale'
              this.listSearchProduct.push(item)
            }
          })
        }
        if (this.searching.length > 2) {
          this.ListaAkcesoria.obudowy.filter((item) => {
          // console.log(item.symbol.startsWith(this.searching))
            if (item.symbol.toLowerCase().includes(this.searching.toLowerCase()) || item.nazwa.toLowerCase().includes(this.searching.toLowerCase())) {
              item.grupa = 'obudowy'
              this.listSearchProduct.push(item)
            }
          })
        }
        if (this.searching.length > 2) {
          this.ListaAkcesoria.zasilacze.filter((item) => {
          // console.log(item.symbol.startsWith(this.searching))
            if (item.symbol.toLowerCase().includes(this.searching.toLowerCase()) || item.nazwa.toLowerCase().includes(this.searching.toLowerCase())) {
              item.grupa = 'zasilacze'
              this.listSearchProduct.push(item)
            }
          })
        }
        if (this.searching.length > 2) {
          this.ListaAkcesoria.switche.filter((item) => {
          // console.log(item.symbol.startsWith(this.searching))
            if (item.symbol.toLowerCase().includes(this.searching.toLowerCase()) || item.nazwa.toLowerCase().includes(this.searching.toLowerCase())) {
              item.grupa = 'switche'
              this.listSearchProduct.push(item)
            }
          })
        }
        this.listSearchProduct.sort()
      }
    },
    wybranie_akcesorium_search (item) {
      this.searching = ''
      this.search_product()

      // if (item.grupa === 'zasilacze') {
      //   this.akcesorium_zasilacze = item
      // } else if (item.grupa === 'switche') {
      //   this.akcesorium_switche = item
      // } else if (item.grupa === 'obudowy') {
      //   this.akcesorium_obudowy = item
      // } else if (item.grupa === 'pozostale') {
      //   this.akcesorium_pozostale = item
      // } else {
      // }

      this.wybranie_akcesorium(item.grupa, item)
    }
    // get_akumulatory () {
    //   this.$store.commit('products/SET_LIST_AKUMULATORY', this.produkty_akumulatory)
    //   // console.log(this.produkty_akcesoria)
    // },
    // get_zasilacze () {
    //   this.$store.commit('products/SET_LIST_ZASILACZE', this.produkty_zasilacze)
    //   // console.log(this.produkty_akcesoria)
    // },
    // get_listwy_d () {
    //   this.$store.commit('products/SET_LIST_LISTWY_D', this.produkty_listwy_d)
    //   // console.log(this.produkty_akcesoria)
    // },
    // get_listwy_z () {
    //   this.$store.commit('products/SET_LIST_LISTWY_Z', this.produkty_listwy_z)
    //   // console.log(this.produkty_akcesoria)
    // },
    // get_materialy () {
    //   this.$store.commit('products/SET_LIST_MATERIALY', this.produkty_materialy)
    //   // console.log(this.produkty_akcesoria)
    // },
    // changeDepth () {
    //   this.changeValueInputs('glebokosc_szafy', 'active', false)
    // },
    // changeBatteryUser () {
    //   this.changeValueOutputs('akumulator_user', 'value', false)
    // },
    // onCancel () {
    //   this.$store.commit('app/SET_DIALOG_INFO', {'active': false, 'text': ''})
    // }
  },
  created () {
    console.log('--- Dane Wejściowe ---')
    window.dataLayer = window.dataLayer || []
    // this.get_config()
    this.get_szafy()
    this.get_all_akcesoria()
    // this.get_akcesoria()
    // this.get_akumulatory()
    // this.get_zasilacze()
    // this.get_listwy_d()
    // this.get_listwy_z()
    // this.get_materialy()
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.prefixList {
  cursor: pointer;
}
.prefixList:hover {
  background: #757474;
  color: white;
}
.prefixList img {
  max-height:50px;
}
.card {
  border-radius: 0px;
}
.card-header {
  padding: 2px;
  background: #535353 !important;
  color:white
}
.card-header h2 {
  background: #535353;
  color: white;
  height: 28px;
  border: none;
  line-height: 0px;
}
.card-header button {
  color: white
}
.card-body {
  padding: 0px;
}
.card-body ul {
  margin-bottom: 0px;
  padding-left: 0px;
}
.card-body ul li {
text-align: left;
list-style: none;
min-height: 40px;
padding: 10px;
cursor: pointer;
}
.card-body ul li:hover {
background: #535353 !important;
color: white;
}
.card-body ul li:nth-child(odd) {
    /* background-color: rgb(241, 241, 241); */
    border-bottom: 1px solid #d9d9d9
}
.card-body ul li:nth-child(even) {
    /* background-color: rgb(219, 219, 219); */
    border-bottom: 1px solid #d9d9d9
}
.btn-link {
  color:#000;
  width: 100%;
  text-align: left;
  text-decoration: none;
  line-height: 14px;
font-size: 13px;
}
.btn-link:hover {
  color: #00c3ff;
  text-decoration: none;
}
.btn-link:focus {
  box-shadow: 0 0 0 0rem rgba(0,123,255,.25);
  text-decoration: none;
}
/* .btn-link.focus, .btn-link:focus {
  text-decoration: underline;
  border-color: transparent;
  box-shadow: none;
} */
/* .show {
  color: #00c3ff;
  text-decoration: none;
} */
#DaneWejsciowe {
  padding-top: 10px;
}
#Content {
  background: #efefef;
}
.row {
margin-top: 15px;
}
.topInfo {
width: 100%;
padding: 4px;
background: #fff;
text-align: left;
color: red;
position: fixed;
z-index: 2;
top: 80px;
}
.topInfo button {
  background: none;
  border:none;
  color: red;
  cursor: pointer;
}
.dialogInfo {
  width: 100%;
  padding: 10px;
  background: #fff;
  text-align: center;
  color: red;
  font-size: 16px;
  font-weight: bold;
}
.dialogInfo svg{
  color: red;
  font-size: 16px;
  font-weight: bold;
}
.dialogInfo button{
  background: none;
  border:none;
  color: red;
  cursor: pointer;
  float:right
}
select.form-control {
    overflow: scroll;
    overflow-x: hidden;
}
.multiselect, .multiselect__input, .multiselect__single {
    font-size: 14px;
}
.multiselect__element {
    height: 28px;
}
.multiselect__option--highlight {
    background: #6e6e6e;
    outline: none;
    color: #fff;
}
.multiselect__option {
    display: block;
    padding: 6px;
    min-height: 20px;
    line-height: 15px;
    text-decoration: none;
    text-transform: none;
    /* vertical-align: middle; */
    position: relative;
    cursor: pointer;
    white-space: nowrap;
}
.inputRabat {
  width: 60px;
  margin-left: 10px;
  padding: 0px 0px 0px 2px;
  margin-top: 0px;
}
#btnPodsumowanie {
  color:white
}
#btnPodsumowanie:hover {
  color:black
}
.btn-check:focus + .btn-info, .btn-info:focus {
    color: #000;
    background-color: none;
    border-color: none;
    box-shadow: none;
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
    box-shadow: none;
}
.btn-info {
    color: white;
    background-color: #00c3ff;
    border-color: #00c3ff;
    padding: 4px 7px;
    border-radius: 0px;
}
.btn-info:hover {
    /* color: #000;
    background-color: #00c3ff;
    border-color: #00c3ff; */
    color: #00c3ff;
    background-color: #fff;
    border-color: #00c3ff;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
color: #fff;
background-color: #00c3ff;
border-color: #00c3ff;
}
.btn-check:focus + .btn-info, .btn-info:focus {
    color: #000;
    background-color: #00c3ff;
    border-color: #00c3ff;
}
.btn-info.disabled, .btn-info:disabled {
    color: #fff;
    background-color: #00c3ff;
    border-color: #00c3ff;
}
.btn-secondary {
color: #fff;
background-color: #535353;
border-color: #535353;
font-size: 12px;
}
.active {
  color: black !important;
}
.topnav {
  position: relative;
  width:205px;
}
.topnav .search-container {
  float: left;
}

.topnav input[type=text] {
    padding: 6px;
    margin-top: 0px;
    font-size: 14px;
    border: none;
    width: 165px;float: left;
    border-radius: 6px;
}

.form-control:focus {
    border:none;
    box-shadow: none;
}
.topnav .search-container button:hover {
  background: #ccc;
}

#productsList {
  position: absolute;
top: 36px;
background: white;
z-index: 10;
width: 564px;
text-align: left;
overflow-y: auto;
}
#productsList ul{
max-height: 310px;
list-style: none;padding: 0px;
}
#productsList ul li button{
text-align: left;
background: none;
border: none;
color: #000;
}
#productsList ul li button:hover{
color: rgb(68, 138, 255)
}

/* #productsList ul li:nth-child(even) {background: #eee;padding: 4px;border-bottom: 1px solid gray;}
#productsList ul li:nth-child(odd) {background: #fff;padding: 4px;border-bottom: 1px solid gray;} */

#productsList ul li:nth-child(even) {background: #fff;padding: 4px;border-bottom: 1px solid gray;}
#productsList ul li:nth-child(odd) {background: #fff;padding: 4px;border-bottom: 1px solid gray;}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.multiselect__placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: white;
  opacity: 1; /* Firefox */
  margin-bottom: 0px;
  padding-top: 2px;
  font-size: 13px;
}
.multiselect__single {
  color: white;
  margin-bottom: 0px;
    margin-bottom: 0px;
    background: #535353;
    font-size: 12px;
}
.multiselect__tags {
  min-height: 28px;
  display: block;
  padding: 2px 40px 0 8px;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  font-size: 14px;
  background: #535353;
  border-radius: 0px;
}

.multiselect__select {
    position: absolute;
    width: 40px;
    height: 26px;
    right: 1px;
    top: 1px;
    padding: 4px 4px;
}
.multiselect {
min-height: 25px;
height: 25px;
margin-bottom: 3px;
cursor: pointer;
}
.form-control:disabled, .form-control[readonly] {
    background-color: #75d6f6;
    opacity: 1;

    border-radius: 6px;
}
/* The container */
.check-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 10px;
  margin-top: 10px;
  cursor: pointer;
  font-size: 14px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color:black
}

/* Hide the browser's default checkbox */
.check-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.check-container .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #d9d9d9;
}

/* On mouse-over, add a grey background color */
.check-container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.check-container input:checked ~ .checkmark {
  background-color: #00c3ff;
}

/* Create the checkmark/indicator (hidden when not checked) */
.check-container .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.check-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.check-container .checkmark:after {
left: 8px;
top: 2px;
width: 8px;
height: 14px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
#turnOff {
color: #b9b9b9
}
</style>



// WEBPACK FOOTER //
// src/components/DaneWejsciowe.vue